<script setup>
import { pageData } from '@/mock/index'
</script>
<template>
  <div class="homePage">
    <div class="homePageTitle">
      <p>为 数 字 安 全 行 业 赋 能</p>
      <p>EMPOWER&nbsp;&nbsp; THE&nbsp;&nbsp;DIGITAL &nbsp;&nbsp;SECURITY &nbsp;&nbsp;INDUSTRY</p>
    </div>
    <div class="homePageMouse">
      <img src="https://p3.ssl.qhimg.com/t019c84bf9960ae406e.png" alt="" />
    </div>
    <div class="homePageMask"></div>
    <video class="homePageVideo" :poster="pageData.poster" autoplay muted loop>
      <source :src="pageData.video" type="video/mp4" />
      您的浏览器不支持 video 标签。
    </video>
  </div>
</template>
<style lang="scss" scoped>
.homePage {
  position: relative;
  width: 100%;
  height: calc(100vh - 64px);
  &Title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    text-align: center;
    p:first-child {
      font-family: TypeRegular;
      font-weight: bold;
      font-size: 72px;
      color: #ffffff;
      margin-bottom: 10px;
    }
    p:last-child {
      font-family: TypeRegular;
      font-weight: bold;
      font-size: 23px;
      color: #ffffff;
    }
  }
  &Mouse {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    cursor: pointer;
    img {
      height: 34px;
    }
  }
  &Video {
    width: 100%;
  }
  &Mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
  }
}
</style>
